import { NgSelectProps } from './../ng-select-props';
import { JsonObject, JsonProperty } from 'json2typescript';
import { Client } from '../clients/client';
import { CaseClientContact } from './caseClientContact';
import { ClientOppDescription } from './clientOppDescription';

@JsonObject('CaseClient')
export class CaseClient {
    @JsonProperty('id', Number, true)
    id: number = undefined;

    @JsonProperty('client', Client, true)
    client: Client = null;

    @JsonProperty('description', ClientOppDescription, true)
    description: ClientOppDescription = null;

    @JsonProperty('contacts', [CaseClientContact], true)
    contacts: CaseClientContact[] = [];

    // write data
    @JsonProperty('case_id', Number, true)
    caseId: number = undefined;

    @JsonProperty('client_id', Number, true)
    clientId: number = undefined;

    @JsonProperty('description_id', Number, true)
    descriptionId: number = undefined;

    // TO handle ng-select issue (create new file component)
    isDeleted = false;

    get name() {
        return this.client.fullName ? this.client.fullName : '—';
    }

    get nameAr() {
        return this.client.nameAr ? this.client.nameAr : '—';
    }

    contactNgSelect: NgSelectProps;
    addContact() {
        this.contacts.push(new CaseClientContact());
    }

    removeContact(contact: CaseClientContact) {
        this.contacts = this.contacts.filter(l => l !== contact);
    }

}

@JsonObject('CaseClientLite')
export class CaseClientLite {
    @JsonProperty('client', String, true)
    client: string = null;

    @JsonProperty('description', String, true)
    description: string = null;
}